export default "__VITE_ASSET__BowuePWE__"